import { render, staticRenderFns } from "./DialogGenerarComprobante.vue?vue&type=template&id=179c2fd0&"
import script from "./DialogGenerarComprobante.vue?vue&type=script&lang=js&"
export * from "./DialogGenerarComprobante.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports